import { Container } from "aurelia-dependency-injection";
import { FaultyDocumentCollection } from "./../../../processing/collections/faulty-document";
import { AdvancedSearchFieldSelectorModel } from "./../../models/advanced-search-field-selector";
import { AdvancedSearchFieldModel } from "./../../models/advanced-search-field";
import { DocumentErrorHelper } from "./../../../shared/helpers/error-helper";
import { BasicTabState } from "./../../../desktop/models/tabs/basic-tab-state";
import { FieldsCollection } from "./../../collections/fields";
import { AdvancedSearchFieldSelectorListView } from "./advanced-search-field-selector-list";
import {backboneViewProperties} from "../../../decorators/backbone-properties";
import { AuthService } from "../../../authentication/auth-service";
import { AppUser } from "../../../authentication/app-user";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const template = require<string>("./advanced-search-field-selector.html");

const dom = {
    FIELD_LIST_REGION: ".field-selector-list-region"
};

@backboneViewProperties({
    template: template
})
export class AdvancedSearchFieldSelectorView extends Marionette.LayoutView<AdvancedSearchFieldSelectorModel> {

    private fieldListRegion: Marionette.Region;
    private fieldListView: AdvancedSearchFieldSelectorListView;
    private fieldCollection: FieldsCollection;
    private user: AppUser;

    constructor(coll: Backbone.Collection<any>, model: AdvancedSearchFieldSelectorModel) {
        super();
        this.model = model;
        this.fieldCollection = coll;
        this.user = ContainerHelper.AuthService.AppUser;
        this.listenTo(this.model, "change:FilterText", this.filterTextChanged);
        this.listenTo(this.fieldCollection, "change:ShowOnForm", this.showOnFormChanged);

        if (this.fieldCollection.first() && this.fieldCollection.first().AdvancedSearch) {
            this.listenTo(this.fieldCollection.first().AdvancedSearch.SearchModel, "change:AdvancedVisible", () => this.model.FilterText = ""); // reset text if we close form
        }
    }

    public regions(): any {
        const regions: any = {
            fieldListRegion: dom.FIELD_LIST_REGION,
        };
        return regions;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click .field-selector-entry"] = (e) => this.fieldClicked(e);
        events["click .field-selector-input"] = (e) => this.inputClicked(e);
        events["keyup .field-selector-input"] = (e) => this.keyPressed(e);
        return events;
    }

    public filterTextChanged() {
        this.$(".field-selector-input").val(this.model.FilterText);
    }

    public onShow() {
        this.setupSubViews();
        this.setupPersonalUserMessage();
    }

    public setupPersonalUserMessage() {
        if (this.user.canUserSaveSearchForm()) {
            this.$(".non-personal-user-message").hide();
        } else {
            this.$(".non-personal-user-message").show();
        }

    }

    public inputClicked(e: JQueryEventObject) {
        this.$(".field-selector-list-region").addClass("open");
        e.preventDefault();
        return false;
    }

    public keyPressed(e: JQueryEventObject) {

        switch (e.keyCode) {
            case 13: // enter
                e.preventDefault();
                this.addSelectedToForm();
                return false;
            case 40: // down
                e.preventDefault();
                this.arrowDown();
                return false;
            case 38: // up
                e.preventDefault();
                this.arrowUp();
                return false;
            case 27: // exc
                e.preventDefault();
                // this.escape();
                return false;
            default:
                this.model.FilterText = $(e.currentTarget).val();
        }

    }

    public showOnFormChanged() {
        if (this.fieldCollection.where((f) => f.ShowOnForm === false).length === 0 ) {
            this.$(".row").hide();
        } else {
            this.$(".row").show();
        }
    }

    public setupSubViews() {

        this.fieldListView = new AdvancedSearchFieldSelectorListView(this.model, {collection: this.fieldCollection});
        this.fieldListRegion.show(this.fieldListView);

    }

    public fieldClicked(e: JQueryEventObject) {
        const id = $(e.currentTarget).data("field-id");
        if (this.addToForm(id)) {
            this.model.FilterText = "";
            this.$(".field-selector-list-region").removeClass("open");
        }
    }

    private arrowUp() {
        const $active = this.$(".field-selector-list-region").find(".selected").removeClass("selected");
        let target: JQuery;
        const li = $active.parent();
        const prevWithLink = li.prevAll().filter(":has(a)").first();
        if (li.length && prevWithLink.length) {
            target = prevWithLink.children("a").addClass("selected");
        } else {
            target = this.$(".field-selector-list-region").find(".field-selector-entry").last().addClass("selected");
        }
        this.$(".dropdown-menu").scrollTo(target);

    }

    private arrowDown() {
        const $active = this.$(".field-selector-list-region").find(".selected").removeClass("selected");
        let target;
        const li = $active.parent();
        const nextWithLink = li.nextAll().filter(":has(a)").first();
        if (li.length && nextWithLink.length) {
            target = nextWithLink.children("a").addClass("selected");
        } else {
            target = this.$(".field-selector-list-region").find(".field-selector-entry").first().addClass("selected");
        }
        this.$(".dropdown-menu").scrollTo(target);
    }

    /**
     * Adds the selected field to the form. If no field is selected but only one is in the list and not filtered out, it will add that one to the form.
     */
    private addSelectedToForm() {
        const visibleFields = this.fieldCollection.where((f) => f.FilteredOut === false && f.ShowOnForm === false);
        if (visibleFields.length === 1) {
            this.$(`[data-field-id="${visibleFields[0].Id}"]`).addClass("selected");
        }

        const el = this.$(".field-selector-entry.selected").first();
        const id = el.data("field-id");
        if (this.addToForm(id)) {
            this.model.FilterText = "";
            this.$(".field-selector-list-region").removeClass("open");
        }
    }

    private addToForm(id: string): boolean {
        const model = this.fieldCollection.findWhere((f) => f.Id.toString() === id.toString());
        if (model) {
            model.addField();
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-field-selector.ts